<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div class="vx-col flex-1" style="padding-left:25px;padding-right:25px">

  <div class="vx-row flex-1 ml-6" >
      <div class="vx-col lg:w-1/2 w-full">
        <p>{{$t('TrainingOrderNumberCourseClass')}}</p>
          <v-select
            label="DisplayName"
            v-model="Assessment.CourseClassID"
            :options="courseClass"
            :reduce="value => value.ID"
           
          />
              </div>

    
    
      
       <div class=" vx-col" style="pl-5">
          <vs-button type="border" class="mb-4 mt-5" icon-pack="feather" @click="Show_question" :disabled="!Assessment.CourseClassID"> {{$t('Show')}} </vs-button>
        </div>
  </div>


  <div class="w-full" style="padding-left:20px;padding-right:20px">   <!-- question  type is text   -->
     
          <div >
           
             <div  :key="indexqr" v-for="(qr, indexqr) in questionResult">
                 <div  class="m-5">
                    
                      <vs-button class="w-full" @click="qr.show=(qr.show==undefined?false:!qr.show)" type="border">{{ qr.QuestionText }}</vs-button>
                    <div class="mt-2" v-if="qr.QuestionTypeID==1&&(qr.show==undefined||qr.show==true)">
                        <div :key="indextr" v-for="(ar, indextr) in qr.AssessmentResults">
                              <p class="product-name font-medium truncate ml-5" v-if="ar.AnswerText">--{{ ar.AnswerText }}</p>
                        </div>
                    </div>

                    <div  class="mt-2" v-if="qr.QuestionTypeID==2&&(qr.show==undefined||qr.show==true)">  <!-- answer is true and false  --> 
                       <br/>
                       <vx-tooltip :text="(qr.Count*100)/numberOfTrainee+ ' %'" position="top">
                         -True  {{((numberOfTrainee-qr.Count)*100)/numberOfTrainee}} %    <vs-progress class="block mt-1" :percent="(qr.Count*100)/numberOfTrainee" color="primary"></vs-progress>
                   </vx-tooltip>
                   <br/>
                    
                    <vx-tooltip :text="((numberOfTrainee-qr.Count)*100)/numberOfTrainee+ ' %'" position="top">
                         -False  {{((numberOfTrainee-qr.Count)*100)/numberOfTrainee}} %    <vs-progress class="block mt-1" :percent="((numberOfTrainee-qr.Count)*100)/numberOfTrainee" color="primary"></vs-progress>
                   </vx-tooltip>  

                    </div> 

                    <div class="mt-2" v-if="(qr.QuestionTypeID==4|| qr.QuestionTypeID==3)&&(qr.show==undefined||qr.show==true)">  <!--  multiple chooice  --> 
                        <div :key="indextr" v-for="(ar, indextr) in qr.CustomerReviewAnswers">
                          <br/>
                            <vx-tooltip v-if="ar.AnswerText" :text="(ar.Count*100)/numberOfTrainee+ ' %'" position="top">
                              {{ ar.AnswerText }} {{(ar.Count*100)/numberOfTrainee}} %   <vs-progress class="block mt-1" :percent="(ar.Count*100)/numberOfTrainee" color="primary"></vs-progress> 
                            </vx-tooltip> 
                            
                        </div>
                    </div>

                 </div>
            
         </div>
      </div>
  </div>
  
  </div>
  
</template>

<script>
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleCategoryAssessment from "@/store/settings/categoryAssessment/moduleCategoryAssessment.js";
import moduleQuestionType from "@/store/settings/questionType/moduleQuestionType.js";
import moduleCourseReview from "@/store/customerReview/courseReview/moduleCourseReview.js";
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import { domain } from '@/gloabelConstant.js'
import vSelect from 'vue-select'
export default {
  components:{
vSelect
  },
  data() {
    return {
      selected: [],
       DownUrl:domain,
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
         Assessment:{},
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      rowDataForDelete: {},
      activeConfirm: false,
      questionWithStattistics:[],
      numberOfTrainee:0,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
   categories() {
      return this.$store.state.CategoryAssessmentList.CategoryAssessments;
    },
    courses() {
      debugger;
      return this.$store.state.courseList.courses;
    },
    questionTypes() {
      return this.$store.state.questionTypeList.questionTypes;
    },
    questionResult(){
      debugger;
      return this.$store.state.CourseReviewList.QuestionsByFilter;
    },
     courseClass() {
      return this.$store.state.courseClassList.courseClass;
    }
  },

  methods: {
   
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },

    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },

    Show_question(){
      debugger; 
        this.getNumberOfTrainee();
        var vm=this;
                this.$vs.loading();

      this.$store.dispatch("CourseReviewList/getQuestionWithResultAnswerByFilter",this.Assessment).then(res=>{
                this.$vs.loading.close();

        res.data.forEach(function(obj){
             vm.$set(obj, 'show', true)
        });
        
      });
    },
    // Show_statistic(){
    //       this.questionWithStattistics=this.$store.state.CourseReviewList.QuestionsByFilter;
    //       this.questionWithStattistics.forEach(Qelement => {
    //         Qelement.AssessmentResults.forEach(element => {
    //           for(let i =0 ; i<Qelement.AssessmentResults.length;i++)

    //           if(element.CustomerReviewAnswer.AnswerText)
    //           const isExist = this.instructorModel.InstructorCourses.findIndex((p) => p.CourseID == this.course.Course.ID);
    //         });
    //       });
    // },
    getNumberOfTrainee(){
      debugger;
      this.$store.dispatch("CourseReviewList/getNumberOfTrainee",this.Assessment).then(res=>{
              console.log(res);
                 this.numberOfTrainee=res.data;
            }).catch(err => {
              console.error(err);
            });
    },
  },

  created() {
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    } 
     
    if (!moduleCategoryAssessment.isRegistered) {
      this.$store.registerModule("CategoryAssessmentList", moduleCategoryAssessment);
      moduleCategoryAssessment.isRegistered = true;
    }
    if (!moduleQuestionType.isRegistered) {
      this.$store.registerModule("questionTypeList", moduleQuestionType);
      moduleQuestionType.isRegistered = true;
    }
    if (!moduleCourseReview.isRegistered) {
      this.$store.registerModule("CourseReviewList", moduleCourseReview);
      moduleCourseReview.isRegistered = true;
    }
      if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }
     this.$store.dispatch("courseClassList/GetCourseClassByInstructorID");
    this.$store.dispatch("CategoryAssessmentList/fetchDataListItems");
    this.$store.dispatch("courseList/fetchDataListItems");
    this.$store.dispatch("questionTypeList/fetchDataListItems");
  
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 5 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
